import "react-toastify/dist/ReactToastify.css";
import LoadingIcon from "@common/LoadingIcon";
import { TitleWithDivider } from "@common/TitleWithDivider";
import { ConfirmCancelButtons } from "@components/Buttons/ConfirmCancelButtons";
import WarningModal from "@components/Modals/WarningModal";
import messages from "@constants/Messages";
import pageHeaders from "@constants/PageHeaders";
import { DepartmentGroupInfo } from "@pages/KAKELY/common/components/DepartmentGroupInfo";
import { useEditDepartmentGroup } from "@pages/KAKELY/EditDepartmentGroupPage/hooks/useEditDepartmentGroup";

const EditDepartmentGroupPage: React.FC = () => {
  const form = useEditDepartmentGroup();

  return (
    <div className="container mx-auto p-4">
      <TitleWithDivider
        titleText={pageHeaders.KAKELY.departmentEdit}
        useDivider={true}
      />
      <div className="flex flex-row justify-end">
        {form.error && (
          <button
            className="button-default"
            type="button"
            onClick={form.handleOpenWarningModal}
          >
            {messages.generic.show_error}
          </button>
        )}
      </div>
      {form.loading || !form.department?.id ? (
        <LoadingIcon></LoadingIcon>
      ) : (
        <form
          className="mayo-card-body border border-text-field-border p-4 mt-4"
          onSubmit={form.handleSave}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
        >
          <DepartmentGroupInfo
            department={form.department}
            errors={form.errors}
            updateError={form.updateError}
            handleInputChange={form.handleInputChange}
          ></DepartmentGroupInfo>

          <div className="flex justify-end items-center">
            <ConfirmCancelButtons
              confirmText={"更新"}
              onCancel={form.onCancel}
              form={true}
            ></ConfirmCancelButtons>
          </div>
        </form>
      )}

      <WarningModal
        title={messages.generic.error_modal_title}
        body={form.error}
        confirmText={""}
        cancelText="戻る"
        isOpen={form.warningModalOpen}
        onRequestClose={form.handleCloseWarningModal}
      ></WarningModal>
    </div>
  );
};

export default EditDepartmentGroupPage;
